// Timer de retour automatique en ligne, style Discord.
// Pas de bannière — l'heure de retour est affichée en tooltip sur le badge de statut.
//
// On utilise setInterval (3s) plutôt qu'un setTimeout long : les navigateurs
// throttlent les setTimeout de longue durée en arrière-plan, ce qui peut
// retarder le déclenchement de plusieurs minutes après l'échéance.

let _timer = null;
let _fin   = null; // timestamp de retour, ou null si pas de timer

export function armerAutoRetour(minutesOuNull) {
    annulerAutoRetour();
    if (!minutesOuNull) return; // "Pour toujours" → pas de timer

    _fin = Date.now() + minutesOuNull * 60 * 1000;
    _majTooltip();

    _timer = setInterval(() => {
        if (Date.now() >= _fin) {
            if (typeof window.changerStatut === 'function') window.changerStatut('enligne');
            // changerStatut appelle annulerAutoRetour() via son propre import
            annulerAutoRetour();
        }
    }, 3000);
}

export function annulerAutoRetour() {
    if (_timer) { clearInterval(_timer); _timer = null; }
    _fin = null;
    _majTooltip();
}

function _majTooltip() {
    const badge = document.getElementById('self-status-badge');
    if (!badge) return;
    if (_fin) {
        const retour = new Date(_fin);
        const h = retour.getHours().toString().padStart(2, '0');
        const m = retour.getMinutes().toString().padStart(2, '0');
        badge.title = `Retour en ligne à ${h}h${m}`;
    } else {
        badge.title = '';
    }
}
